import { render, staticRenderFns } from "./DOrganizeEditor.vue?vue&type=template&id=05b03ca6&"
import script from "./DOrganizeEditor.vue?vue&type=script&lang=js&"
export * from "./DOrganizeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports